import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import EditPatient from "../../components/editPatient";
import StickyLogo from "../../components/stickyLogo";

const PatientEdit = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <EditPatient />
    </Main>
  </>
);

export default PatientEdit;
